import fetchRamsRecords from '../../../Services/fetchRamsRecords'

export default () => (dispatch) => {

  dispatch(fetchRamsRecords())

}
